module.exports = __webpack_public_path__ + "img/完成.9f022eca.png";